import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVisibilityOffAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M12.479 7.52c.292.292.528.643.708 1.053.18.41.285.837.313 1.281a.717.717 0 0 1-.223.531.728.728 0 0 1-.527.219.754.754 0 0 1-.546-.219.714.714 0 0 1-.225-.531 1.666 1.666 0 0 0-.094-.77 1.81 1.81 0 0 0-.385-.615 1.543 1.543 0 0 0-.594-.386c-.23-.083-.483-.11-.76-.083a.716.716 0 0 1-.532-.223.728.728 0 0 1-.218-.527c0-.208.072-.386.218-.531a.723.723 0 0 1 .531-.22c.445.029.869.13 1.271.303a3.38 3.38 0 0 1 1.063.719M9.999 5.5c-.231 0-.457.007-.676.022-.22.014-.439.041-.658.08a.924.924 0 0 1-.592-.113.729.729 0 0 1-.365-.458.72.72 0 0 1 .073-.573.619.619 0 0 1 .464-.318c.295-.052.587-.088.877-.109.29-.02.582-.031.878-.031 1.86 0 3.573.476 5.135 1.427 1.563.951 2.748 2.261 3.555 3.93.054.109.09.216.112.32a1.647 1.647 0 0 1 0 .645c-.021.105-.052.213-.094.324a7.57 7.57 0 0 1-.914 1.477c-.363.46-.76.89-1.19 1.293a.704.704 0 0 1-1.042-.087.725.725 0 0 1-.177-.551c.02-.2.108-.375.26-.528.362-.32.684-.667.966-1.042.283-.375.53-.778.743-1.208a7.692 7.692 0 0 0-3.01-3.302A8.266 8.266 0 0 0 10 5.5M10 16a9.216 9.216 0 0 1-5.02-1.448 10.36 10.36 0 0 1-3.606-3.848.938.938 0 0 1-.134-.34 2.098 2.098 0 0 1 0-.729.961.961 0 0 1 .136-.344c.32-.625.692-1.208 1.12-1.75a9.42 9.42 0 0 1 1.463-1.479L2.396 4.5a.718.718 0 0 1-.23-.521c0-.194.077-.368.23-.52a.729.729 0 0 1 1.062 0l13.083 13.083c.153.152.23.326.23.52a.718.718 0 0 1-.23.521.729.729 0 0 1-1.062 0l-2.188-2.166A9.546 9.546 0 0 1 10 16M5.022 7.146c-.487.389-.938.816-1.355 1.28-.416.466-.757.99-1.02 1.574a7.692 7.692 0 0 0 3.01 3.302A8.266 8.266 0 0 0 10 14.5a7.64 7.64 0 0 0 1.064-.073 11.04 11.04 0 0 0 1.04-.198l-.938-.937a3.64 3.64 0 0 1-.583.156A3.314 3.314 0 0 1 10 13.5c-.973 0-1.799-.34-2.48-1.021-.68-.68-1.02-1.507-1.02-2.48 0-.194.024-.388.073-.583.048-.194.093-.388.135-.583z"
      />
    </g>
  </svg>
);
export default SvgVisibilityOffAlt;
